import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";

export const getSimpleTypographyCellRenderer =
  (
    key: keyof SavingsOpportunity,
    secondaryKey?: keyof SavingsOpportunity,
  ): FC<CustomCellRendererProps<SavingsOpportunity>> =>
  (cell) => {
    const data = cell.data as SavingsOpportunity;
    const firstValue = data?.[key];
    const secondaryValue = secondaryKey ? data?.[secondaryKey] : "";
    const value = firstValue || secondaryValue;

    if (typeof value !== "string" || !value) {
      return null;
    }

    return <TypographyWithCopy value={value} variant="body2" />;
  };
